<template>
    <div component="ContractTemplate">
        <page-header :icon="'videocam'" :text="'Contract template'"></page-header>
        <section container="main">
            <v-snackbar
                :class="{ snackbarError: !status, snackbarSuccess: status }"
                class="text-center"
                centered
                v-model="showStatus"
            >
                <h3 class="text-center" v-if="status">Template was saved.</h3>
                <h3 class="text-center" v-else>There was error saving template.</h3>
            </v-snackbar>

            <ckeditor v-model="template" :config="editorConfig"></ckeditor>
            <div class="template-actions">
                <v-btn @click="template = templateBackup" class="warning"> RESET </v-btn>
                <v-btn @click="saveTemplate" class="success"> SAVE </v-btn>
            </div>
        </section>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import TextEditor from '@/components/TextEditor/TextEditor.vue';

export default {
    name: 'ContractTemplate',

    components: {
        PageHeader,
        TextEditor,
    },

    data() {
        return {
            editorConfig: {
                extraAllowedContent: '*[*]{*}(*)',
                entities: false,
                basicEntities: false,
                forceSimpleAmpersand: true,
            },
            templateBackup: null,
            showStatus: false,
            status: false,
        };
    },

    async mounted() {
        await this.loadCurrentContractTemplate();
        this.templateBackup = this.getContractTemplate;
    },

    methods: {
        ...mapMutations(['setContractTemplate']),
        ...mapActions(['loadCurrentContractTemplate', 'storeContractTemplate']),

        async saveTemplate() {
            try {
                await this.storeContractTemplate();
                this.status = true;
            } catch (e) {
                this.status = false;
                throw e;
            } finally {
                this.showStatus = true;
            }
        },
    },

    computed: {
        ...mapGetters(['getContractTemplate']),

        template: {
            get() {
                return this.getContractTemplate;
            },
            set(val) {
                this.setContractTemplate(val);
            },
        },
    },
};
</script>
<style lang="less" scoped>
[component='ContractTemplate'] {
    padding: 0px 30px 10px 30px;
    height: 100%;
    width: 100%;
    position: absolute;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    [container='main'] {
        padding: 0px 30px 10px 30px;
        display: flex;
        flex-direction: column;
        max-width: 100%;
    }

    .template-actions {
        flex-grow: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        .v-btn {
            color: inherit;
            background: inherit;
        }
    }
}
</style>
<style lang="less">
@import '~@variables';

.snackbarSuccess {
    .v-snack__wrapper {
        background: @success;
    }
}
.snackbarError {
    .v-snack__wrapper {
        background: @error;
    }
}

[component='ContractTemplate'] {
    display: flex;
    flex-direction: column;

    [container='main'] {
        display: flex;
        flex-direction: column;
        min-height: auto !important;
        height: auto !important;
        flex: 1;

        & > div {
            display: flex;
            flex: 1;
            flex-direction: column;

            #cke_editor1 {
                flex: 1;
                display: flex;
                flex-direction: column;

                .cke_inner.cke_reset {
                    flex: 1;
                    display: flex;
                    flex-direction: column;

                    #cke_1_contents {
                        flex: 1 !important;
                    }
                }
            }
        }
    }
}
</style>
